<template>
  <div class="btn btn-switch switch p-0" :class="{
    active: shouldBeChecked
  }">
    <input 
      type="checkbox" 
      class="mt-1"  
      :checked="shouldBeChecked" 
      :value="value" 
      @change="updateInput"
    />
    <label class="left">{{labelLeft}}</label>
    <span class="switch-icon">
      <div class="icon"></div>
    </span>
    <label class="right">{{labelRight}}</label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    value: {
      type: String,
    },
    modelValue: {
      default: false
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    labelRight: {
      type: String,
      default: 'No'
    },
    labelLeft: {
      type: String,
      default: 'Yes'
    }
  },

  computed: {
    shouldBeChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }
      return this.modelValue === this.trueValue
    }
  },

  methods: {
    updateInput(event) {
      let isChecked = event.target.checked

      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue]

        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }

        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    }
  }
}
</script>
